/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pricing_Unable_Start_CheckoutInputs */



/**
* | output |
* | --- |
* | "Unable to start checkout session." |
*
* @param {Pricing_Unable_Start_CheckoutInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const pricing_unable_start_checkout = /** @type {((inputs?: Pricing_Unable_Start_CheckoutInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pricing_Unable_Start_CheckoutInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Checkout-Session konnte nicht gestartet werden.")
	return /** @type {LocalizedString} */ ("Unable to start checkout session.")
});